/**
 * 知识图谱 ECharts option 构建
 * 接口字段：
 * - nodes[].id / label：节点标识 / 展示文案
 * - nodes[].distance：节点颜色
 * - nodes[].degree：节点关联度（决定大小）
 * - edges[].source / target / value / label：连线两端、强度、关系文案
 */
function scaleSymbolSize(degree, minDegree, maxDegree) {
    const minSize = 36;
    const maxSize = 88;
    if (maxDegree <= minDegree) return (minSize + maxSize) / 2;
    return minSize + ((degree - minDegree) / (maxDegree - minDegree)) * (maxSize - minSize);
}

export function buildGraphOption(graph) {
    const rawNodes = (graph && graph.nodes) || [];
    const rawEdges = (graph && graph.edges) || [];
    const degrees = rawNodes.map((item) => Number(item.degree) || 0);
    const minDegree = Math.min(...degrees, 0);
    const maxDegree = Math.max(...degrees, 1);
    const maxEdgeValue = Math.max(...rawEdges.map((item) => Number(item.value) || 1), 1);

    const nodes = rawNodes.map((item) => {
        const degree = Number(item.degree) || 0;
        const color = item.distance || '#17becf';
        const name = item.id;
        const displayName = item.label || item.id;
        return {
            id: name,
            name,
            displayName,
            value: degree,
            symbolSize: scaleSymbolSize(degree, minDegree, maxDegree),
            itemStyle: { color },
            label: {
                show: true,
                position: 'inside',
                color: '#333',
                fontSize: 12,
                formatter: displayName,
            },
        };
    });

    const links = rawEdges.map((item) => {
        const value = Number(item.value) || 1;
        return {
            source: item.source,
            target: item.target,
            value,
            label: item.label
                ? { show: true, formatter: item.label, fontSize: 10 }
                : { show: false },
            lineStyle: {
                width: 1 + (value / maxEdgeValue) * 4,
                curveness: 0.15,
                opacity: 0.55,
                color: '#94A3B8',
            },
        };
    });

    return {
        tooltip: {
            trigger: 'item',
            formatter(params) {
                if (params.dataType === 'edge') {
                    const { source, target, value } = params.data || {};
                    return `${source} → ${target}<br/>关联强度：${value || 1}`;
                }
                const data = params.data || {};
                return `${data.displayName || data.name || ''}<br/>关联度：${data.value || 0}`;
            },
        },
        series: [
            {
                type: 'graph',
                layout: 'force',
                roam: true,
                draggable: true,
                data: nodes,
                links,
                label: {
                    show: true,
                    position: 'inside',
                    color: '#fff',
                },
                force: {
                    repulsion: 280,
                    edgeLength: [50, 160],
                    gravity: 0.08,
                },
                emphasis: {
                    focus: 'adjacency',
                    lineStyle: { width: 4 },
                },
            },
        ],
    };
}
